// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"l1-z","displaySixCardTiles":"m1-z"};